import { Box, BoxProps, CircularProgress } from "@mui/material";

interface ICircularLoadingProps extends BoxProps {
  isLoading: boolean;
}

export const CircularLoading = (props: ICircularLoadingProps) => {
  const { isLoading, children, ...rest } = props;
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
        {...rest}
      >
        <CircularProgress />
      </Box>
    );
  }
  return <>{children}</>;
};
